import { createApp } from 'vue'
import App from './App.vue'
import { i18n } from './i18n'
import router from './router'
import { registerUi } from '@ui-bootstrap'

// Global styles
import './styles/variables.css'
import './styles/reset.css'
import './styles/utilities.css'

const app = createApp(App)

registerUi(app)
app.use(i18n)
app.use(router)
app.mount('#app')
